import { FC } from "react";
import { withConditionalComponent } from "src/HOC";
import DestinationComponentWeb from "./layouts/DestinationComponent.web";
import DestinationComponentMob from "./layouts/DestinationComponent.mob";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { PlaneArrivalIcon } from "@Icons/index";
import { useTranslation } from "react-i18next";
import i18n from "src/i18n";

const DestinationSelectComponent = withConditionalComponent(DestinationComponentWeb, DestinationComponentMob);

const DestinationComponent: FC<any> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const name = "destination";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: PlaneArrivalIcon,
    label: t("Flights.search.to"),
    hasError,
    rules: [{ required: true, message: i18n.t("Flights.search.destinationRequired") }],
    className: "flex-5 h-15! border-none! focus:outline-none! focus-within:ring-0! w-full",
  };

  return <DestinationSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default DestinationComponent;
